import { render, staticRenderFns } from "./printModel.vue?vue&type=template&id=20c1544c&scoped=true&"
import script from "./printModel.vue?vue&type=script&lang=js&"
export * from "./printModel.vue?vue&type=script&lang=js&"
import style0 from "./printModel.vue?vue&type=style&index=0&id=20c1544c&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20c1544c",
  null
  
)

export default component.exports